import script from "./ChatSidebarSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSidebarSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSidebarSearchBar.vue?vue&type=style&index=0&id=1bc5c4ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc5c4ba"]])

export default __exports__